import { useMemo } from "react";
import { useSettings } from "@/contexts/SettingsContext";

export function ScriptureVerse({ verse: verseProp, className = "" }) {
  const { settings } = useSettings();
  const verse = useMemo(() => {
    if (verseProp) return verseProp;
    if (!settings?.verses_enabled) return null;
    const enabled = (settings.scripture_verses || []).filter((v) => v.enabled);
    if (!enabled.length) return null;
    const dayIndex = new Date().getUTCDate();
    return enabled[dayIndex % enabled.length];
  }, [verseProp, settings]);

  if (!verse) return null;

  return (
    <figure
      data-testid="scripture-verse"
      className={`relative rounded-2xl bg-cream-100 border border-cream-300 shadow-card px-6 py-6 sm:px-8 sm:py-7 ${className}`}
    >
      <div
        className="absolute -top-3 left-6 h-6 w-6 rounded-full bg-terracotta-500 opacity-90"
        aria-hidden
      />
      <blockquote className="font-serif italic text-lg sm:text-xl leading-relaxed text-charcoal">
        &ldquo;{verse.text}&rdquo;
      </blockquote>
      <figcaption
        data-testid="scripture-attribution"
        className="mt-3 font-sans text-sm uppercase tracking-widest text-terracotta-500"
      >
        {verse.attribution}
      </figcaption>
    </figure>
  );
}
